import { jsx } from 'react/jsx-runtime';
import { isChunkTextOrString, isChunkText, isKnownChunk, sanitizeBlockType } from '../../../types.js';
import { useLlm } from '../../../useLlm/useLlm.js';

const Chunk = _ref => {
  let {
    item,
    chunkIndex,
    index,
    total,
    role
  } = _ref;
  const blocks = useLlm(state => state.blocks);
  const messageProps = {
    chunkIndex,
    index,
    total,
    role,
    first: index === 0,
    last: index === total - 1
  };
  const props = Object.assign(Object.assign({}, messageProps), {
    item
  });
  if (isChunkTextOrString(item)) {
    const text = (isChunkText(item) ? item.text : item.content) || '';
    return text.length > 0 && (role === 'user' ? blocks.userMessage(Object.assign(Object.assign({}, messageProps), {
      role: 'user',
      text
    })) : blocks.assistantMessage(Object.assign(Object.assign({}, messageProps), {
      role: 'assistant',
      text
    })));
  }
  if (isKnownChunk(item, blocks)) {
    switch (item.type) {
      case 'image_url':
        {
          return item.image_url ? jsx("div", {
            className: "llm__row",
            children: jsx("div", {
              className: "llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6",
              children: jsx("img", {
                src: item.image_url.url,
                alt: ""
              })
            })
          }) : jsx("code", {
            children: JSON.stringify(item)
          });
        }
      default:
        {
          const type = sanitizeBlockType(item.type);
          const block = blocks[type];
          return block(props);
        }
    }
  } else {
    return blocks.notFound(props);
  }
};

export { Chunk };
//# sourceMappingURL=chunk.js.map
